import React, { createContext, useState, useMemo } from 'react'
import { node } from 'prop-types'

const initialState = {
    page: "pageList",
    pageList: {        
        data: [],
    },
    addUpdate: {
        data: {
            name: "",
            type: "Özel Dersane",
            userlimit: "",
            passiveDate: "",
            description: "",
            isActive: true,
        }
    },
}

export const CompaniesContext = createContext(initialState);

export function CompaniesStore({ children }) {
    const [state, setState] = useState(initialState);
    const providerState = useMemo(() => ({ state, setState }), [state, setState])
    return (
        <CompaniesContext.Provider value={providerState}>
            {children}
        </CompaniesContext.Provider>
    )
}

CompaniesStore.defaultProps = {
    children: null
}

CompaniesStore.propTypes = {
    children: node
}


